module.exports = __webpack_public_path__ + "new-window-link-2153c64b002471d4a35db2fd36e443a3.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/icons/new-window-link.svg
// module id = 54
// module chunks = 0